<template>
    <apexchart :width="width ? width : '99%'" :options="options" :series="series"></apexchart>
    <!-- <apexchart width="600" :options="options" :series="series"></apexchart>
    <apexchart width="600" :options="options1" :series="series1"></apexchart>
    <apexchart width="600" :options="options" :series="series"></apexchart> -->
</template>


<script>
import VueApexCharts from "vue3-apexcharts";

export default {
  name: 'ApexComponent',
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    width: Number,
    options: Object,
    series: Array,
  },
  setup() {
    // const colors = ["#008FFB", "#00E396", "#FEB019", "#FF4560", "#775DD0"];

    return {    };
  },
};
</script>